module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBoldItalic.8afe4dc1.ttf";